
import Vue from "vue";

export default Vue.extend({
  name: "Currency",

  data: () => ({
    currencyValues: {
      EUR: require("@/assets/images/locales/eu.svg"),
      USD: require("@/assets/images/locales/us.svg"),
      RUB: require("@/assets/images/locales/ru.svg"),
      RON: require("@/assets/images/locales/ro.svg"),
      UAH: require("@/assets/images/locales/ua.svg")
    },
    currencies: [] as Array<any>,
    timer: null as any
  }),

  computed: {
    hasAccessToken() {
      return this.$store.getters["authentication/hasAccessToken"];
    }
  },

  async mounted() {
    await this.loadData();
    this.timer = setInterval(this.loadData, 300000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    async loadData() {
      try {
        this.currencies = await this.$API.exchangeRates().getDataCurrent();
      } catch (e) {
        if (e.message) {
          await this.$store.dispatch("alert/showError", e.message);
        }
      }
    }
  }
});
